import { useState } from 'react';
import { useSelector } from 'react-redux';

import { selectSsid } from '@app/redux';

export const useFormValues = () => {
  const { ssidName, ssidLoading: loading } = useSelector(selectSsid);

  const [wifiName, setWifiName] = useState(ssidName || '');
  const [newPasswordValue, setNewPasswordValue] = useState('');
  const [retypePasswordValue, setRetypePasswordValue] = useState('');

  const hasSsidChanged = wifiName !== ssidName;
  const isSsidNameValid = !hasSsidChanged || (wifiName.length >= 5 && wifiName.length <= 63);
  const isPasswordLengthValid = newPasswordValue.length >= 8 && newPasswordValue.length <= 63;
  const doPasswordsMatch = newPasswordValue === retypePasswordValue;

  const values = {
    wifiName,
    newPasswordValue,
    retypePasswordValue,
  };

  const handlers = {
    onNameChange: setWifiName,
    onPasswordChange: setNewPasswordValue,
    onConfirmPasswordChange: setRetypePasswordValue,
    onReset: () => {
      setNewPasswordValue('');
      setRetypePasswordValue('');
    },
  };

  const validation = { isSsidNameValid, isPasswordLengthValid, doPasswordsMatch };

  const canSave =
    isSsidNameValid &&
    isPasswordLengthValid &&
    doPasswordsMatch &&
    wifiName.length > 0 &&
    newPasswordValue.length > 0 &&
    retypePasswordValue.length > 0;

  return { values, handlers, validation, loading, canSave };
};
